import React from "react";
import { useLang } from "@/lib/i18n";

export default function LangSwitcher({ compact = false }) {
  const { lang, setLang } = useLang() || {};
  if (!lang) return null;
  return (
    <div className={`inline-flex items-center border border-[var(--mel-border)] rounded-full overflow-hidden text-xs ${compact ? "" : "ml-2"}`} data-testid="lang-switcher">
      <button
        onClick={() => setLang("it")}
        data-testid="lang-it"
        className={`px-3 py-1.5 uppercase tracking-widest transition-colors ${lang === "it" ? "bg-[var(--mel-text)] text-white" : "hover:bg-[var(--mel-surface)]"}`}
      >
        IT
      </button>
      <button
        onClick={() => setLang("en")}
        data-testid="lang-en"
        className={`px-3 py-1.5 uppercase tracking-widest transition-colors ${lang === "en" ? "bg-[var(--mel-text)] text-white" : "hover:bg-[var(--mel-surface)]"}`}
      >
        EN
      </button>
    </div>
  );
}
